import Helper from "./Helper";

const Header = {
  init: () => {
    // get mobile nav btn
    const btn = document.getElementById("header__btn");

    // mobile nav toggle
    if (btn) {
      btn.addEventListener("click", function (e) {
        Helper.toggleBtn(e.currentTarget);
      });
    }
  },
};

export default Header;
